interface LoadingSpinnerProps {
  large?: boolean;
  label?: string;
}

export function LoadingSpinner({ large, label }: LoadingSpinnerProps) {
  return (
    <div className="cs-empty">
      <div className={`cs-spinner${large ? ' cs-spinner--lg' : ''}`} />
      {label && <p className="cs-empty__desc" style={{ marginTop: 16 }}>{label}</p>}
    </div>
  );
}
